import { defineMessages } from 'react-intl';

const scope = 't.component.PortalAppNavigation';

export default defineMessages({
	home: {
		id: `${scope}.home`,
		defaultMessage: 'Home',
	},
	users: {
		id: `${scope}.users`,
		defaultMessage: 'Utenti',
	},
	usersList: {
		id: `${scope}.users.usersList`,
		defaultMessage: 'Elenco Utenti',
	},
	usersManagement: {
		id: `${scope}.users.usersManagement`,
		defaultMessage: 'Crea Utente',
	},
	transactions: {
		id: `${scope}.transactions`,
		defaultMessage: 'Transazioni',
	},
	transactionList: {
		id: `${scope}.transactions.transactionList`,
		defaultMessage: 'Elenco transazioni',
	},
	postAccountingTransfer: {
		id: `${scope}.transactions.postAccountingTransfer`,
		defaultMessage: 'Storno post contabilizzazione',
	},
	groups: {
		id: `${scope}.groups`,
		defaultMessage: 'Gruppi',
	},
	groupsList: {
		id: `${scope}.groups.groupsList`,
		defaultMessage: 'Elenco Gruppi',
	},
	groupManagement: {
		id: `${scope}.groups.groupManagement`,
		defaultMessage: 'Crea Gruppo',
	},
	store: {
		id: `${scope}.store`,
		defineMessages: 'Negozio',
	},
	storeList: {
		id: `${scope}.store.storeList`,
		defineMessages: 'Elenco negozi',
	},
	storeManagement: {
		id: `${scope}.store.storeManagement`,
		defineMessages: 'Crea negozio',
	},
	register: {
		id: `${scope}.register`,
		defineMessages: 'Casse',
	},
	registerList: {
		id: `${scope}.register.registerList`,
		defineMessages: 'Elenco casse',
	},
	registerManagement: {
		id: `${scope}.register.registerManagement`,
		defineMessages: 'Crea cassa',
	},
	electronicPurse: {
		id: `${scope}.electronicPurse`,
		defineMessages: 'Borsellino',
	},
	couponList: {
		id: `${scope}.electronicPurse.couponList`,
		defineMessages: 'Elenco Borsellini',
	},
	couponManagement: {
		id: `${scope}.electronicPurse.couponManagement`,
		defineMessages: 'Crea Borsellino',
	},
	promotions: {
		id: `${scope}.promotions`,
		defaultMessage: 'Promozioni',
	},
	promotionList: {
		id: `${scope}.promotions.promotionList`,
		defaultMessage: 'Elenco promozioni',
	},
	cashbackList: {
		id: `${scope}.promotions.cashbackList`,
		defaultMessage: 'Elenco Cashback',
	},
	newPromotion: {
		id: `${scope}.promotions.newPromotion`,
		defaultMessage: 'Crea Promozione',
	},
	merchant: {
		id: `${scope}.merchant`,
		defaultMessage: 'Gruppi',
	},
	merchantList: {
		id: `${scope}.merchant.merchantList`,
		defaultMessage: 'Elenco Gruppi',
	},
	merchantManagement: {
		id: `${scope}.merchant.merchantManagement`,
		defaultMessage: 'Crea Gruppo',
	},
	customerCare: {
		id: `${scope}.customerCare`,
		defaultMessage: 'Customer Care',
	},
	searchUser: {
		id: `${scope}.customerCare.searchUser`,
		defaultMessage: 'Ricerca Utente',
	},
	searchTransactions: {
		id: `${scope}.customerCare.searchTransactions`,
		defaultMessage: 'Ricerca Transazioni',
	},
	logout: {
		id: `${scope}.exit`,
		defaultMessage: 'Esci',
	},
	profile: {
		id: `${scope}.profile`,
		defaultMessage: 'Profilo',
	},
	annulla: {
		id: `t.global.abort`,
		defaultMessage: 'Annulla',
	},
	conferma: {
		id: `t.global.confirm`,
		defaultMessage: 'Conferma',
	},
	esci: {
		id: `t.global.logout`,
		defaultMessage: 'Esci',
	},
	titolo: {
		id: `t.global.logoutTitle`,
		defaultMessage: 'Sei sicuro di voler uscire \ndal portale dedicato?',
	},
});
